import { isValid as isValidCpf } from '../cpf'
import { isValid as isValidCnpj } from '../cnpj'

export default function cpf() {
  return this.test('cpf', 'cpfCnpjInvalid', value => {
    return `${value}`.length <= 11 ? isValidCpf(value) : isValidCnpj(value)
  })
}
